var _g, _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTransaction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4096_24729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4538 43.6611L69.5694 36.5455C72.5821 33.7996 76.537 32.3201 80.6122 32.4144C84.6874 32.5088 88.5695 34.1697 91.4519 37.0521C94.3343 39.9344 95.9952 43.8166 96.0895 47.8918C96.1839 51.967 94.7044 55.9218 91.9585 58.9345L81.7882 69.0689C80.3224 70.5401 78.5806 71.7075 76.6627 72.504C74.7447 73.3006 72.6884 73.7106 70.6116 73.7106C68.5348 73.7106 66.4785 73.3006 64.5606 72.504C62.6426 71.7075 60.9008 70.5401 59.4351 69.0689",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5487 84.3347L59.4331 91.4503C56.4204 94.1962 52.4655 95.6757 48.3903 95.5814C44.3151 95.487 40.433 93.8261 37.5506 90.9437C34.6682 88.0614 33.0073 84.1792 32.9129 80.104C32.8186 76.0288 34.2981 72.0739 37.044 69.0613L47.2143 58.9269C48.6801 57.4556 50.4219 56.2883 52.3398 55.4917C54.2578 54.6952 56.3141 54.2852 58.3909 54.2852C60.4676 54.2852 62.524 54.6952 64.4419 55.4917C66.3599 56.2883 68.1017 57.4556 69.5674 58.9269",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64,
    r: 9,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 0.782609,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2987 61.2481C68.5279 61.0189 68.5279 60.6472 68.2987 60.418C68.0694 60.1888 67.6978 60.1888 67.4686 60.418L64.6083 63.2783L61.7486 60.4185C61.5194 60.1893 61.1477 60.1893 60.9185 60.4185C60.6893 60.6478 60.6893 61.0194 60.9185 61.2486L63.7782 64.1083L60.9185 66.9681C60.6893 67.1973 60.6893 67.5689 60.9185 67.7982C61.1477 68.0274 61.5194 68.0274 61.7486 67.7982L64.6083 64.9384L67.4686 67.7987C67.6978 68.0279 68.0694 68.0279 68.2987 67.7987C68.5279 67.5695 68.5279 67.1978 68.2987 66.9686L65.4384 64.1083L68.2987 61.2481Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1792 48.933L41.0542 48.237M51.2594 45.0584L42.0199 39.0682M53.8996 41.7373L51.2883 36.4998",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1891 81.0678L88.7554 83.9197M78.0672 83.8083L85.0187 92.348M74.5342 86.1573L75.4095 91.9439",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4096_24729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(18.5 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTransaction);
export default __webpack_public_path__ + "static/media/emptyTransaction.128857664e56130c3b09a2645dce23ba.svg";
export { ForwardRef as ReactComponent };